import type { DietFlag, Recipe } from "./types";

export const is = (recipe: Recipe, prop: DietFlag): boolean => {
  return ![...recipe.ingredients].some((item) => item[prop] !== true);
};

export const isVegetarian = (recipe: Recipe): boolean => is(recipe, "vegetarian");

export const isVegan = (recipe: Recipe): boolean => is(recipe, "vegan");

export const isKeto = (recipe: Recipe): boolean => is(recipe, "keto");

export const time = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const minutes_remainder = minutes - 60 * hours;

  return minutes > 60 ? `${hours}h ${minutes_remainder ? `${minutes - 60 * hours}m` : ""}` : `${minutes}m`;
};
